import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NativeBarcodeReaderInputComponent } from './native-barcode-reader-input.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [NativeBarcodeReaderInputComponent],
    exports: [NativeBarcodeReaderInputComponent],
    imports: [CommonModule, TranslateModule, FormsModule],
})
export class NativeBarcodeReaderInputModule {}
